import { render, staticRenderFns } from "./ContractTermRequests.vue?vue&type=template&id=12418375&"
import script from "./ContractTermRequests.vue?vue&type=script&lang=js&"
export * from "./ContractTermRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports